<template>
  <v-data-table
    :headers="virtualBomDataTableHeaders"
    :items="virtualBomList"
    :search="searchVirtualBom"
    class="elevation-1 ma-5"
    show-expand
    single-expand
    item-key="Id"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :loading="isLoadingVirtualBom"
    :loading-text="$t('common_get_data')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>虛擬BOM表管理</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchVirtualBom"
          append-icon="mdi-magnify"
          :label="$t('bom_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditVirtualBomDialog" fullscreen persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
              新增虛擬BOM表
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ virtualBomDialogTitle }}</span>
              <v-spacer></v-spacer>
              <v-btn v-if="editedVirtualBomIndex !== -1" icon fab @click="copyVirtualBom">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="dialogNameAndPrice">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('bom_name')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedVirtualBom.Name"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable || editedVirtualBomIndex !== -1"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('bom_quantity')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedVirtualBom.Quantity"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_quantity') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('bom_price')"
                        :rules="{ required: true, regex: /^[0-9]+$/ }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedVirtualBom.Price"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_price') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="2" xl="2" lg="2">
                      <ValidationProvider
                        :name="$t('bom_unit')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedVirtualBom.Unit"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_unit') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="1" xl="1" lg="1">
                      <v-checkbox
                        v-model="editedVirtualBom.IsActive"
                        label="啟用"
                        :disabled="isAllTextFieldDisable"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        outlined
                        v-model="editedVirtualBom.Describe"
                        :label="$t('bom_describe')"
                        :disabled="isAllTextFieldDisable"
                        @keyup.enter="focusNextInput"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        outlined
                        v-model="editedVirtualBom.Remark"
                        :label="$t('quotation_item_remark')"
                        :disabled="isAllTextFieldDisable"
                        @keyup.enter="focusNextInput"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-data-table
              :headers="bomItemDataTableHeaders"
              :items="editedVirtualBom.BomItems"
              :search="searchBomItem"
              class="elevation-1  mt-5 mx-10"
              hide-default-footer
              disable-pagination
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              :header-props="headerProps"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('bom_item_tool_bar_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchBomItem"
                    append-icon="mdi-magnify"
                    :label="$t('bom_item_search_label')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog v-model="isShowEditBomItemDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-8"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="isAllTextFieldDisable"
                      >
                        {{ $t('bom_item_new_btn') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ bomItemDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBomItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <item-filter-all-type-combobox
                                  refName="itemCombobox"
                                  :fatherEditedItem="editedItem"
                                  :editedItemIndex="editedBomItemIndex"
                                  :itemName="'bom_item_name'"
                                  @setEditedItem="setEditedItem"
                                  @keyupEnter="focusNextInput"
                                  v-if="editedBomItemIndex === -1 && isShowEditBomItemDialog"
                                />
                                <ValidationProvider
                                  :name="$t('bom_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedItem.Name"
                                    disabled
                                    required
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('bom_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <v-text-field
                                  v-model="editedItem.Number"
                                  disabled
                                  :label="$t('bom_item_number')"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('bom_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedItem.Quantity"
                                    required
                                    :error-messages="errors[0]"
                                    clearable
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('bom_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('bom_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedItem.Price"
                                    required
                                    :error-messages="errors[0]"
                                    clearable
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('bom_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('bom_item_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedItem.WarrantyPeriod"
                                    required
                                    :error-messages="errors[0]"
                                    clearable
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('bom_item_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditBomItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addBomItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="isShowEditBomItemFromBomDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-8"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="isAllTextFieldDisable"
                      >
                        {{ $t('quotation_item_new_install_new_bom_btn') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ bomItemDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBomItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <quotation-bom-autocomplete
                                  :fatherEditedItem="editedBomItem"
                                  :editedItemIndex="editedBomItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :customerDeviceType="0"
                                  @setBomItem="setBomItem"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditBomItemFromBom">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addBomItemFromBom">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="isAllTextFieldDisable"
                    :isLoadingSaveBtn="isLoadingSaveBtn"
                    :isShowDeleteDialog="isShowDeleteBomItemDialog"
                    :deleteMessage="'bom_item_delete_dialog_message'"
                    @closeDelete="closeDeleteBomItem"
                    @confirmDelete="confirmDeleteBomItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  small
                  @click="isShowEditBomItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisable"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="isShowDeleteBomItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisable"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditVirtualBomDialog"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveVirtualBom"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="isBomItemNullDialog" max-width="500" persistent>
          <v-card color="error">
            <v-card-title class="text-h1"></v-card-title>
            <v-card-text class="white--text text-h5">
              <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
              {{ $t('bom_save_alert') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="isBomItemNullDialog = false">
                {{ $t('common_close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isDeleteBtnDisable"
          :isLoadingSaveBtn="isLoadingDeleteBtn"
          :isShowDeleteDialog="isShowDeleteVirtualBomDialog"
          :deleteMessage="'bom_delete_dialog_message'"
          @closeDelete="closeDeleteVirtualBom"
          @confirmDelete="confirmDeleteVirtualBom"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.CreateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.CreateTime) }}
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon small @click="isShowEditVirtualBomDialogBtn(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon small @click="isShowDeleteVirtualBomDialogBtn(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" style="background-color: rgb(223, 219, 219);">
        <v-simple-table style="background-color: rgb(223, 219, 219);">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('bom_item_name') }}
                </th>
                <th class="text-left">
                  {{ $t('bom_item_number') }}
                </th>
                <th class="text-right">
                  {{ $t('bom_item_quantity') }}
                </th>
                <th class="text-right">
                  {{ $t('bom_item_price') }}
                </th>
                <th class="text-right">
                  {{ $t('bom_item_warranty_period') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="simpleItem in item.BomItems" :key="simpleItem.Number">
                <td class="text-left">{{ simpleItem.Name }}</td>
                <td class="text-left">{{ simpleItem.Number }}</td>
                <td class="text-right">{{ simpleItem.Quantity }}</td>
                <td class="text-right">{{ simpleItem.Price }}</td>
                <td class="text-right">{{ simpleItem.WarrantyPeriod }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { HttpVirtualBom } from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import axios from 'axios'
import ItemFilterAllTypeCombobox from '@/components/ItemFilterAllTypeCombobox.vue'
import QuotationBomAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomAutocomplete.vue'

extend('regex', regex)

export default {
  components: { DeleteDialog, ItemFilterAllTypeCombobox, QuotationBomAutocomplete },
  name: 'VirtualBom',
  data () {
    return {
      getIntersectingObj: null,
      isShowEditVirtualBomDialog: false,
      isShowDeleteVirtualBomDialog: false,

      searchVirtualBom: '',
      virtualBomList: [],
      editedVirtualBomIndex: -1,
      editedVirtualBom: {
        Number: '',
        Name: '',
        Price: 0,
        Unit: '組',
        Quantity: 0,
        Describe: '',
        BomItems: [],
        CreateTime: 0,
        CreateBy: '',
        UpdateTime: 0,
        UpdateBy: '',
        Remark: '',
        IsActive: true
      },
      defaultBom: {
        Number: '',
        Name: '',
        Price: 0,
        Unit: '組',
        Describe: '',
        Quantity: 0,
        BomItems: [],
        CreateTime: 0,
        CreateBy: '',
        UpdateTime: 0,
        UpdateBy: '',
        Remark: '',
        IsActive: true
      },

      isShowEditBomItemDialog: false,
      isShowDeleteBomItemDialog: false,

      searchBomItem: '',
      editedBomItemIndex: -1,
      editedItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        Price: 0,
        RepairPrice: 0,
        WarrantyPeriod: 0,
        RepairWarrantyPeriod: 0
      },
      defaultItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        Price: 0,
        RepairPrice: 0,
        WarrantyPeriod: 0,
        RepairWarrantyPeriod: 0
      },
      isLoadingVirtualBom: false,
      isLoadingSaveBtn: false,
      isAllTextFieldDisable: false,
      isLoadingDeleteBtn: false,
      isDeleteBtnDisable: false,
      isBomItemNullDialog: false,
      bomSource: null,
      updateBomSource: null,
      addBomSource: null,
      deleteBomSource: null,
      editedBomItem: {
        Name: '',
        BomItems: []
      },
      defaultBomItem: {
        Name: '',
        BomItems: []
      },
      isShowEditBomItemFromBomDialog: false
    }
  },

  computed: {
    virtualBomDialogTitle () {
      return this.editedVirtualBomIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    bomItemDialogTitle () {
      return this.editedBomItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    virtualBomDataTableHeaders () {
      return [
        { text: this.$t('bom_name'), value: 'Name' },
        { text: this.$t('bom_describe'), value: 'Describe' },
        { text: this.$t('bom_price'), value: 'Price' },
        { text: '啟用', value: 'IsActive', sortable: false },
        { text: this.$t('bom_create_time'), value: 'CreateTime' },
        { text: this.$t('bom_create_by'), value: 'CreateBy' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    bomItemDataTableHeaders () {
      return [
        { text: this.$t('bom_item_name'), value: 'Name' },
        { text: this.$t('bom_item_number'), value: 'Number' },
        { text: this.$t('bom_item_quantity'), value: 'Quantity' },
        { text: this.$t('bom_item_price'), value: 'Price' },
        { text: this.$t('bom_item_warranty_period'), value: 'WarrantyPeriod' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  async mounted () {
    await this.getAllVirtualBom()
  },
  methods: {
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setEditedItem (val) {
      this.editedItem = JSON.parse(JSON.stringify(val))
    },
    convertToDateTimeFormat (timestamp) {
      return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
    },
    isShowEditVirtualBomDialogBtn (item) {
      this.editedVirtualBomIndex = this.virtualBomList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedVirtualBom = JSON.parse(str)
      this.isShowEditVirtualBomDialog = true
    },

    isShowDeleteVirtualBomDialogBtn (item) {
      this.editedVirtualBomIndex = this.virtualBomList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedVirtualBom = JSON.parse(str)
      this.isShowDeleteVirtualBomDialog = true
    },

    async confirmDeleteVirtualBom () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingVirtualBom = true
      if (this.deleteBomSource) {
        this.deleteBomSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.deleteBomSource = cancelToken.source()
      await HttpVirtualBom.DeleteVirtualBom(
        this.virtualBomList[this.editedVirtualBomIndex].Id,
        this.deleteBomSource.token
      )
      this.deleteBomSource = null
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingVirtualBom = false
      await this.getAllVirtualBom()
      // this.virtualBomList.splice(this.editedVirtualBomIndex, 1)
      this.closeDeleteVirtualBom()
    },

    async closeEditVirtualBomDialog () {
      this.isShowEditVirtualBomDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultBom)
        this.editedVirtualBom = JSON.parse(str)
        this.editedVirtualBomIndex = -1
      })
      await this.getAllVirtualBom()
    },

    closeDeleteVirtualBom () {
      this.isShowDeleteVirtualBomDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultBom)
        this.editedVirtualBom = JSON.parse(str)
        this.editedVirtualBomIndex = -1
      })
    },
    async getAllVirtualBom () {
      this.isLoadingVirtualBom = true
      let response = await HttpVirtualBom.GetAllVirtualBom()
      if (response) {
        this.virtualBomList = response.status === 200 ? response.data.Data : []
      }
      this.isLoadingVirtualBom = false
    },

    async saveVirtualBom () {
      let isExist =
        this.editedVirtualBom.Id !== ''
          ? this.virtualBomList.findIndex(
            (x) =>
              x.Id !== this.editedVirtualBom.Id &&
                x.Name === this.editedVirtualBom.Name &&
                x.Describe === this.editedVirtualBom.Describe
          ) !== -1
          : this.virtualBomList.findIndex(
            (x) =>
              x.Name === this.editedVirtualBom.Name &&
                x.Describe === this.editedVirtualBom.Describe
          ) !== -1
      if (!isExist) {
        const isValid = await this.$refs.dialogNameAndPrice.validate()
        if (isValid) {
          if (this.editedVirtualBom.BomItems.length === 0) {
            this.isBomItemNullDialog = true
          } else {
            this.isLoadingSaveBtn = true
            this.isLoadingVirtualBom = true
            this.setAllTextFieldDisable()
            if (this.editedVirtualBomIndex > -1) {
              if (this.updateBomSource) {
                this.updateBomSource.cancel('cancel')
              }
              let cancelToken = axios.CancelToken
              this.updateBomSource = cancelToken.source()
              await HttpVirtualBom.UpdateVirtualBom(
                this.editedVirtualBom,
                this.updateBomSource.token
              )
              this.updateBomSource = null
            } else {
              if (this.addBomSource) {
                this.addBomSource.cancel('cancel')
              }
              let cancelToken = axios.CancelToken
              this.addBomSource = cancelToken.source()
              await HttpVirtualBom.AddVirtualBom(this.editedVirtualBom, this.addBomSource.token)
              this.addBomSource = null
            }
            await this.getAllVirtualBom()
            this.closeEditVirtualBomDialog()
          }
        }
      } else {
        alert('此BOM已存在')
      }
    },
    setAllTextFieldDisable () {
      this.isAllTextFieldDisable = true
    },

    isShowEditBomItemDialogBtn (item) {
      this.editedBomItemIndex = this.editedVirtualBom.BomItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedItem = JSON.parse(str)
      this.isShowEditBomItemDialog = true
    },

    isShowDeleteBomItemDialogBtn (item) {
      this.editedBomItemIndex = this.editedVirtualBom.BomItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedItem = JSON.parse(str)
      this.isShowDeleteBomItemDialog = true
    },

    confirmDeleteBomItem () {
      this.editedVirtualBom.BomItems.splice(this.editedBomItemIndex, 1)
      this.closeDeleteBomItem()
    },

    closeEditBomItem () {
      this.isShowEditBomItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultItem)
        this.editedItem = JSON.parse(str)
        this.editedBomItemIndex = -1
      })
    },

    closeDeleteBomItem () {
      this.isShowDeleteBomItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultItem)
        this.editedItem = JSON.parse(str)
        this.editedBomItemIndex = -1
      })
    },
    async addBomItem () {
      const isValid = await this.$refs.dialogBomItem.validate()
      if (isValid) {
        if (this.editedBomItemIndex > -1) {
          this.editedVirtualBom.BomItems.splice(this.editedBomItemIndex, 1, this.editedItem)
        } else {
          this.editedVirtualBom.BomItems.push(this.editedItem)
        }
        this.closeEditBomItem()
      }
    },
    copyVirtualBom () {
      this.editedVirtualBom.Id = ''
      this.editedVirtualBomIndex = -1
    },

    setBomItem (val) {
      if (val) {
        this.editedBomItem = JSON.parse(JSON.stringify(val))
      } else {
        this.editedBomItem = JSON.parse(JSON.stringify(this.defaultBomItem))
      }
    },
    addBomItemFromBom () {
      this.editedBomItem.BomItems.forEach((element) => {
        let index = this.editedVirtualBom.BomItems.findIndex((x) => x.Name === element.Name)
        if (index === -1) {
          this.editedVirtualBom.BomItems.push(element)
        }
      })
      this.closeEditBomItemFromBom()
    },
    closeEditBomItemFromBom () {
      this.editedBomItem = JSON.parse(JSON.stringify(this.defaultBomItem))
      this.isShowEditBomItemFromBomDialog = false
    }
  }
}
</script>
